module.exports = __webpack_public_path__ + "img/all.3a5521ae.svg";